module.exports = __webpack_public_path__ + "static/img/bengjing(1).17c43d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bengjing(1).png
// module id = RHhQ
// module chunks = 26